import Vue from 'vue';
import Router from 'vue-router';
import SignupPage from './views/SignUpPage.vue';
import AccountSetup from './views/account-setup/AccountSetup.vue';
import PersonalInfo from './views/account-setup/PersonalInfo.vue';
import UploadCertificate from './views/account-setup/UploadCertificate.vue';
import UploadDocuments from './views/account-setup/UploadDocuments.vue';
import Questionnaire from './views/account-setup/Questionnaire.vue';
import AddDrivers from './views/account-setup/AddDrivers.vue';
import HealthInsuranceInfo from './views/account-setup/HealthInsuranceInfo.vue';
import { MedTransGoConstants } from './util/constants';
import MainLayout from './views/MainLayout.vue';
import RequestPanel from './views/RequestPanel.vue';
import AcceptRequest from './views/AcceptRequest.vue';
import ServiceRequestDetails from './views/ServiceRequestDetails.vue';
import Setting from './views/Setting.vue';
import ViewCertificateModal from './views/modal/ViewCertificateModal.vue';
import ViewRequestDetailModal from './views/modal/ViewRequestDetailModal.vue';
import Payout from './views/Payouts.vue';
import Requests from './views/Requests.vue';
import UnderReviewPage from './views/UnderReviewPage.vue';
import UpdateLocationModal from './views/modal/UpdateLocationModal.vue';
import AddDriverModal from './views/modal/AddDriverModal.vue';
import UpdateDriverModal from './views/modal/UpdateDriverModal.vue';
import ViewDriverDetailModal from './views/modal/ViewDriverDetailModal.vue';
import UpdateUserProfileModal from './views/modal/UpdateUserProfileModal.vue';
import Calendar from './views/Calendar.vue';
import UploadRejectedDocument from './views/UploadRejectedDocument.vue';
import AuctionModal from './views/modal/AuctionModal.vue';
import UpdateDocumentModal from './views/modal/UpdateDocumentModal.vue';
import UploadDocumentsModal from './views/modal/UploadDocumentsModal.vue';
import HealthInsurance from './views/HealthInsurance.vue';
import AddUserModal from './views/modal/AddUserModal.vue';
import TermAndConditions from './views/TermsAndConditions.vue';
import store from './store';

Vue.use(Router);

const router =  new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: MedTransGoConstants.URL_SIGNUP,
      name: MedTransGoConstants.VIEW_SIGNUP_NAME,
      pathToRegexpOptions: {
        strict: true,
      },
      component: SignupPage,
    },
    {
      path: MedTransGoConstants.URL_TERMSANDCONDITIONS,
      name: MedTransGoConstants.VIEW_TERMSANDCONDITIONS_NAME,
      component: TermAndConditions,
    },
    {
      path: MedTransGoConstants.URL_REVIEW_PROGRESS,
      name: MedTransGoConstants.VIEW_REVIEW_PROGRESS_NAME,
      pathToRegexpOptions: {
        strict: true,
      },
      component: UnderReviewPage,
    },
    {
      path: MedTransGoConstants.URL_REJECTED_DOCUMENTS,
      name: MedTransGoConstants.VIEW_REJECTED_DOCUMENTS,
      component: UploadRejectedDocument,
    },
    {
      path: MedTransGoConstants.URL_HEALTH_INSURANCE,
      name: MedTransGoConstants.VIEW_HEALTH_INSURANCE,
      component: HealthInsurance,
    },
    {
      path: MedTransGoConstants.URL_ACCOUNT_SETUP,
      component: AccountSetup,
      children: [
        {
          path: MedTransGoConstants.URL_PERSONAL_INFO,
          name: MedTransGoConstants.VIEW_PERSONAL_INFO_NAME,
          component: PersonalInfo,
        },
        {
          path: MedTransGoConstants.URL_UPLOAD_CERTIFICATE,
          name: MedTransGoConstants.VIEW_UPLOAD_CERTIFICATE_NAME,
          component: UploadCertificate,
        },
        {
          path: MedTransGoConstants.URL_UPLOAD_DOCUMENTS,
          name: MedTransGoConstants.VIEW_UPLOAD_DOCUMENTS_NAME,
          component: UploadDocuments,
        },
        {
          path: MedTransGoConstants.URL_TRANSPORTATION_QUESTIONNAIRE,
          name: MedTransGoConstants.VIEW_TRANSPORTATION_QUESTIONNAIRE_NAME,
          component: Questionnaire,
        },
        {
          path: MedTransGoConstants.URL_HEALTH_INSURANCE_INFO,
          name: MedTransGoConstants.VIEW_HEALTH_INSURANCE_INFO_NAME,
          component: HealthInsuranceInfo,
        },
        {
          path: MedTransGoConstants.URL_DRIVER_INFO,
          name: MedTransGoConstants.VIEW_DRIVER_INFO_NAME,
          component: AddDrivers,
         },
      ],
    },
    {
      path: '/',
      component: MainLayout,
      children: [
        {
          path: MedTransGoConstants.URL_REQUESTS,
          name: MedTransGoConstants.VIEW_REQUESTS_PANEL_NAME,
          component: RequestPanel,
          children: [
            {
              path: ':id/accept',
              name: MedTransGoConstants.VIEW_ACCEPT_REQUESTS_NAME,
              component: AcceptRequest,
            },
            {
              path: ':id/bidNow',
              name: MedTransGoConstants.VIEW_AUCTION_NAME,
              component: AuctionModal,
            },
            {
              path: ':id',
              name: MedTransGoConstants.VIEW_REQUEST_DETAILS_NAME,
              component: ServiceRequestDetails,
            },
          ],
        },
        {
          path: MedTransGoConstants.URL_CALENDAR,
          name: MedTransGoConstants.VIEW_CALENDAR_NAME,
          component: Calendar,
          children: [
            {
              path: ':id',
              name: MedTransGoConstants.VIEW_REQUEST_DETAILS_MODAL_NAME,
              component: ViewRequestDetailModal,
            },
          ],
        },
        {
          path: MedTransGoConstants.URL_REQUESTS_TABLE,
          name: MedTransGoConstants.VIEW_REQUESTS_TABLE_NAME,
          component: Requests,
          children: [
            {
              path: ':id',
              name: MedTransGoConstants.VIEW_REQUEST_DETAILS_MODAL_NAME,
              component: ViewRequestDetailModal,
            },
          ],
        },
        {
          path: MedTransGoConstants.URL_SETTING,
          name: MedTransGoConstants.VIEW_SETTING_NAME,
          component: Setting,
          children: [
            {
              path: `${MedTransGoConstants.URL_INTERPRETERSID}/${MedTransGoConstants.URL_CERTIFICATEID}`,
              name: MedTransGoConstants.VIEW_CERTITIFICATE_NAME,
              component: ViewCertificateModal,
            },
            {
              path: MedTransGoConstants.URL_UPDATE_LOCATION + '/:id',
              name: MedTransGoConstants.VIEW_UPDATE_LOCATION_NAME,
              component: UpdateLocationModal,
            },
            {
              path: MedTransGoConstants.URL_UPDATE_TRANSPORTER_DOCUMENT + '/:id',
              name: MedTransGoConstants.VIEW_UPDATE_TRANSPORTER_DOCUMENT,
              component: UpdateDocumentModal,
            },
            {
              path: MedTransGoConstants.URL_UPLOAD_DOCUMENT + '/:id',
              name: MedTransGoConstants.VIEW_UPLOAD_DOCUMENT,
              component: UploadDocumentsModal,
            },
            {
              path: MedTransGoConstants.URL_ADD_DRIVER,
              name: MedTransGoConstants.VIEW_ADD_DRIVER_NAME,
              component: AddDriverModal,
            },
            {
              path: MedTransGoConstants.URL_UPDATE_DRIVER + '/:id',
              name: MedTransGoConstants.VIEW_UPDATE_DRIVER_NAME,
              component: UpdateDriverModal,
            },
            {
              path: MedTransGoConstants.URL_VIEW_DRIVER + '/:id',
              name: MedTransGoConstants.VIEW_DRIVER_NAME,
              component: ViewDriverDetailModal,
            },
            {
              path: MedTransGoConstants.URL_UPDATE_PROFILE + '/:id',
              name: MedTransGoConstants.VIEW_UPDATE_PROFILE,
              component: UpdateUserProfileModal,
            },
            {
              path: MedTransGoConstants.URL_ADD_USER,
              name: MedTransGoConstants.VIEW_ADD_UESR_NAME,
              component: AddUserModal,
            },
          ],
        },
        {
          path: MedTransGoConstants.URL_PAYOUT,
          name: MedTransGoConstants.VIEW_PAYOUT_NAME,
          component: Payout,
          children: [
            {
              path: ':id',
              name: MedTransGoConstants.VIEW_REQUEST_DETAILS_MODAL_NAME,
              component: ViewRequestDetailModal,
            },
          ],
        },
      ],
    },
  ],
});

router.beforeEach((to, from, next) => {
  if (store.state.isChildInterpreter && to.path.startsWith('/payouts')) {
    next(from.path);
  } else {
    next();
  }
});

export default router;
